import { ref } from "vue";

const footerContent = ref<{
  text: string;
  link: { path: string; query: Record<string, string | string[] | undefined> };
} | null>(null);

// eslint-disable-next-line import/prefer-default-export
export const useSettingsFooter = () => {
  const setFooterContent = (content: typeof footerContent.value) => {
    footerContent.value = content;
  };
  return { footerContent, setFooterContent };
};
